module.exports = __webpack_public_path__ + "img/certificateServices-img.3047b813.png";